'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Controller = exports.t = exports.switchLanguage = exports.i18nPlugin = exports.I18nProvider = exports.MemoryMVC = exports.HashMVC = exports.BrowserMVC = undefined;

var _browserMvc = require('./browser-mvc');

var _browserMvc2 = _interopRequireDefault(_browserMvc);

var _hashMvc = require('./hash-mvc');

var _hashMvc2 = _interopRequireDefault(_hashMvc);

var _memoryMvc = require('./memory-mvc');

var _memoryMvc2 = _interopRequireDefault(_memoryMvc);

var _i18nProvider = require('./i18n-provider');

var _i18nProvider2 = _interopRequireDefault(_i18nProvider);

var _i18n = require('./plugin/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _Controller = require('react-router-controller/libs/Controller');

var _Controller2 = _interopRequireDefault(_Controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BrowserMVC = _browserMvc2.default;
exports.HashMVC = _hashMvc2.default;
exports.MemoryMVC = _memoryMvc2.default;
exports.I18nProvider = _i18nProvider2.default;
exports.i18nPlugin = _i18n2.default;
exports.switchLanguage = _i18n.switchLanguage;
exports.t = _i18nProvider.t;
exports.Controller = _Controller2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mvc-react/libs/index.js
// module id = 1207
// module chunks = 0